import { render, staticRenderFns } from "./PosTableContainer.vue?vue&type=template&id=2f41dbbe&scoped=true"
import script from "./PosTableContainer.vue?vue&type=script&lang=js"
export * from "./PosTableContainer.vue?vue&type=script&lang=js"
import style0 from "./PosTableContainer.vue?vue&type=style&index=0&id=2f41dbbe&prod&lang=scss&scoped=true"
import style1 from "./PosTableContainer.vue?vue&type=style&index=1&id=2f41dbbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41dbbe",
  null
  
)

export default component.exports